import React, { useMemo, useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import round from '../../../helpers/round';
import MuiSnackbar from '../../common/MuiSnackbar';

const InputLayer = ({ layer, updateLayer, isLoadingSave, isLoadingCalculate, isLoadingLoad }) => {
  const regexForPositiveDecimals = /^[+]?\d*(?:[.]\d*)?$/;

  const onChangeWarningForPositiveDecimals = (e, variable, variableSetter) => {
    if (regexForPositiveDecimals.test(e.target.value)) {
      variableSetter(e);
    } else {
      showMuiSnack(`${variable}: Can only be a postive number. `, 'warning');
    }
  };

  const changeZ2 = (e) => {
    updateLayer('z2', e.target.value);
  };

  const changeFormation = (e) => {
    updateLayer('formation', e.target.value);
  };

  const changeC = (e) => {
    updateLayer('c', e.target.value);
  };

  const changePhi = (e) => {
    updateLayer('phi', e.target.value);
  };

  const hasZ2OrderError = useMemo(() => {
    if (layer?.z1 === '' || layer?.z1 == null || layer?.z2 === '' || layer?.z2 == null) return false;
    const z1 = Number(layer?.z1);
    const z2 = Number(layer?.z2);
    if (!Number.isFinite(z1) || !Number.isFinite(z2)) return false;
    return z2 <= z1;
  }, [layer?.z1, layer?.z2]);
  //MUI ALERT
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [severity, setSeverity] = useState('');

  const showMuiSnack = (message, type) => {
    setAlertMessage(message);
    setSeverity(type);
    setOpen(true);
  };

  return (
    <div className="layer layered-soil-layer">
      <MuiSnackbar open={open} setOpen={setOpen} severity={severity} alertMessage={alertMessage} />
      {/* INPUTS IN LAYERS */}
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
          '& .MuiInputBase-input.Mui-disabled': {
            color: '#777',
            WebkitTextFillColor: '#777',
          },
          '& .MuiOutlinedInput-root.Mui-disabled fieldset': {
            borderColor: '#ccc',
            backgroundColor: '#aaa7a74d',
          },
        }}
        fullWidth
        size="small"
        variant="outlined"
        className="layeredDisabledInput"
        disabled
        inputProps={{ readOnly: true }}
        value={layer.id}
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        fullWidth
        size="small"
        variant="outlined"
        value={layer.formation}
        onChange={changeFormation}
        disabled={isLoadingCalculate || isLoadingLoad || isLoadingSave}
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
          '& .MuiInputBase-input.Mui-disabled': {
            color: '#777',
            WebkitTextFillColor: '#777',
          },
          '& .MuiOutlinedInput-root.Mui-disabled fieldset': {
            borderColor: '#ccc',
            backgroundColor: '#aaa7a74d',
          },
        }}
        fullWidth
        size="small"
        variant="outlined"
        className="layeredDisabledInput"
        disabled
        inputProps={{ readOnly: true }}
        value={layer.z1}
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        fullWidth
        size="small"
        variant="outlined"
        value={layer.z2}
        onChange={(e) => onChangeWarningForPositiveDecimals(e, 'z2', changeZ2)}
        disabled={isLoadingCalculate || isLoadingLoad || isLoadingSave}
        inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
        error={hasZ2OrderError}
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
          '& .MuiInputBase-input.Mui-disabled': {
            color: '#777',
            WebkitTextFillColor: '#777',
          },
          '& .MuiOutlinedInput-root.Mui-disabled fieldset': {
            borderColor: '#ccc',
            backgroundColor: '#aaa7a74d',
          },
        }}
        fullWidth
        size="small"
        variant="outlined"
        className="layeredDisabledInput"
        disabled
        inputProps={{ readOnly: true }}
        value={layer.hi > 0 ? layer.hi : ''}
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        fullWidth
        size="small"
        variant="outlined"
        value={layer.c}
        onChange={(e) => onChangeWarningForPositiveDecimals(e, 'Cohesion', changeC)}
        disabled={isLoadingCalculate || isLoadingLoad || isLoadingSave}
        inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        fullWidth
        size="small"
        variant="outlined"
        value={layer.phi}
        onChange={(e) => onChangeWarningForPositiveDecimals(e, 'Friction Angle', changePhi)}
        disabled={isLoadingCalculate || isLoadingLoad || isLoadingSave}
        inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
      />
    </div>
  );
};

export default InputLayer;
